import React from "react";
import { ShoppingBag } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";

const HIDDEN_PATHS = ["/admin", "/success", "/cancel"];

export default function CartButton() {
  const cart = useCart();
  const location = useLocation();
  if (cart.count === 0) return null;
  if (HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) return null;
  if (location.pathname.startsWith("/order/")) return null;
  return (
    <button
      onClick={cart.open}
      data-testid="cart-floating-btn"
      className="fixed bottom-20 md:bottom-6 right-6 md:right-52 z-40 inline-flex items-center gap-3 bg-[#FF3B30] hover:bg-white hover:text-black text-white pl-5 pr-6 py-4 shadow-[0_15px_40px_-10px_rgba(255,59,48,0.6)] transition-colors group"
      aria-label="Open cart"
    >
      <span className="relative">
        <ShoppingBag className="w-5 h-5" />
        <span
          data-testid="cart-count-badge"
          className="absolute -top-2 -right-3 bg-white text-black font-['Anton'] text-[11px] tracking-wider w-5 h-5 flex items-center justify-center rounded-full"
        >
          {cart.count}
        </span>
      </span>
      <span className="font-['Anton'] tracking-widest uppercase text-sm">
        View Order · ${cart.subtotal.toFixed(2)}
      </span>
    </button>
  );
}
